import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';

@Component({
  selector: 'app-register-melvin-louise',
  templateUrl: './register-melvin-louise.component.html',
  styleUrls: ['./register-melvin-louise.component.scss']
})
export class RegisterMelvinLouiseComponent implements OnInit {

  // constructor() { }

  // ngOnInit(): void {
  // }

  //add user form start
  registerForm: FormGroup;
  submitted = false;
  router: any;
  constructor(public fb: FormBuilder, private http: HttpClient, private _router: Router) {
    this.registerForm = this.fb.group({
      name: new FormControl('', [Validators.required, Validators.minLength(3)]),
      email: new FormControl('', [Validators.required, Validators.email]),
      phone: ['', [Validators.required,
      Validators.pattern("^[0-9]*$"),
      Validators.minLength(10), Validators.maxLength(10)]],
      address: [''],
      city: 'bhandara',
      member: ['']
    })
  }
  //^(\+91[\-\s]?)?[0]?(91)?[789]\d{9}$
  get f() { return this.registerForm.controls; }
  //Add user form actions
  submitForm() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.registerForm.invalid) {
      return;
    }

    var formData: any = new FormData();

    formData.append("name", this.registerForm.value.name);
    formData.append("email", this.registerForm.value.email);
    formData.append("phone", this.registerForm.value.phone);
    formData.append("address", this.registerForm.value.address);
    formData.append("member", this.registerForm.value.member);
    formData.append("city", this.registerForm.value.city);

    //console.log(formData);
    this.http.post('https://ghrscf.com/includes/register.php', formData).subscribe(
      (response: any) => console.log(response),
      (error: any) => console.log(error)
    );
    // this.router.navigate(['/demo']);
    this._router.navigateByUrl('/thank-you');

  }

  ngOnInit(): void {
  }
}
